define.alias("shared/helpers/uuid", "settings/helpers/uuid");